module.exports = __webpack_public_path__ + "img/bb_g1_t_ears-02.07395d0f.svg";